import { Injectable, OnDestroy } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { endOfDay } from 'date-fns';
import { APIKey } from '../models/api-key';
import { EntityFormService, Form } from '../util/entity-form.service';

export interface APIKeyForm extends Form<any> {
  name: FormControl<string>;
  type: FormControl<string>;
  expiresAt: FormControl<Date | null>;
}

@Injectable()
export class APIKeyFormService
  extends EntityFormService<APIKey, APIKeyForm>
  implements OnDestroy
{
  constructor(protected fb: FormBuilder) {
    super();
    super.initialize();
  }

  protected initializeForm() {
    this.form = new FormGroup({
      name: new FormControl('', [Validators.required]),
      type: new FormControl('', [Validators.required]),
      expiresAt: new FormControl(null),
    });
  }

  public buildEntity(entity: Partial<APIKey> = {}): APIKey {
    const formValue = this.form.value;
    const expires_at = formValue.expiresAt
      ? endOfDay(formValue.expiresAt)
      : undefined;
    return {
      ...entity,
      name: formValue.name,
      type: formValue.type,
      expires_at,
    };
  }
}
